<template>
<!-- 城市-汇付账户-提现 -->
    <el-dialog :visible.sync="show" width="600px" append-to-body :before-close="closeDialog">
        <el-form ref="form" :model="submit_data" label-width="80px">
            <el-form-item label="提现金额:" label-width="120px">
                <el-input v-model="submit_data.amount" placeholder="提现金额" style="width: 60%"> </el-input>
                <div style="font-size:12px;color:#606266">注: 汇付账户提现需要保留足够金额，否则司机无法正常提现</div>
            </el-form-item>
        </el-form>

        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center">
            <submitBtn
                @onSubmitDig="onSubmitDig"
                :data="submit_data"
                :rules="submit_rules"
                :url="submit_url"
                :JSON_Boolean="false"
            ></submitBtn>
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newDate, oldData) {
            _this.show = true;
        }
    },
    data() {
        return {
            show: false,
            submit_url: '/huifu/cash',

            submit_data: {
                amount: ''
            },
            submit_rules: {
                amount: {
                    placeholder: '提现金额',
                    rules: {
                        required: true,
                        message: '提现金额',
                        regulation: 'number',
                        rulesData: '0'
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
      

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_data = {
                amount: ''
            };
        }
    }
};
</script>
<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
}
</style>

